<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title
        >{{ mode === 'edit' ? '修改' : '新增' }} Function(Module:
        {{ module.module_name }})</v-card-title
      >
      <v-card-actions>
        <v-btn @click="update" :disabled="!valid" v-if="mode === 'edit'"
          >修改</v-btn
        >
        <v-btn @click="save" :disabled="!valid" v-else>保存</v-btn>
        <v-btn @click="close">戻る</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                label="code"
                v-model="functionMap.code"
                :rules="[(v) => !!v || `code is required`]"
                :disabled="mode === 'edit'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="function_name"
                v-model="functionMap.function_name"
                :rules="[(v) => !!v || `function_name is required`]"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      selecetd: '',
      show: false,
      functionMap: {},
      valid: false,
      module: {},
      mode: '',
    }
  },
  methods: {
    close() {
      this.show = false
    },
    popupNew(module, func) {
      this.show = true
      this.module = module
      this.functionMap = { ...func }
      this.mode = 'new'
    },
    popupEdit(module, func) {
      this.popupNew(module, func)
      this.mode = 'edit'
    },
    save() {
      this.$http
        .post('/basic-data/sys-functions', {
          ...this.functionMap,
          standard_code: '001',
          description: '',
        })
        .then((res) => {
          if (res.data.ret_code === '00000') {
            this.$message('', this.$t('app.messages.saveSuccess'))
            this.$emit('refresh')
          } else {
            this.$message('', `${res.data.ret_code}: ${res.data.ret_msg}`)
          }

          this.close()
        })
        .catch((res) => {
          this.$message(
            '',
            `${res.response.data.ret_code}: ${res.response.data.ret_msg}`
          )
        })
    },

    update() {
      this.$http
        .patch('/basic-data/sys-functions', {
          function_id: this.functionMap.function_id,
          function_name: this.functionMap.function_name,
        })
        .then((res) => {
          if (res.data.ret_code === '00000') {
            this.$message('', this.$t('app.messages.saveSuccess'))
            this.$emit('refresh')
          } else {
            this.$message('', `${res.data.ret_code}: ${res.data.ret_msg}`)
          }

          this.close()
        })
        .catch((res) => {
          this.$message(
            '',
            `${res.response.data.ret_code}: ${res.response.data.ret_msg}`
          )
        })
    },
  },
}
</script>

<style>
.select-area {
  border: 2px solid #000;
  height: 300px;
}
</style>
